var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Атрибуты объектов'),  path: `/attrentity`,  icon: 'vip_icon icon_suppliers'}}})
}
var staticRenderFns = []

export { render, staticRenderFns }